import React from 'react';
import cn from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { withTranslation } from 'react-i18next';

import FIELD_TYPES from '../../../configs/fieldTypes';
import { SETTINGS_KEYS } from '../../../configs/viewSettings';

import SelectColor from '../../Cards/Header/Config/Overlay/Select/Color';
import SelectSort from '../../Cards/Header/Config/Overlay/Select/Sort';
import SelectSortDirection from '../../Cards/Header/Config/Overlay/Select/SortDirection';

import styles from './properties.less';
import viewSettingsActions from '../../../actions/viewSettingsActions';
import UrlParamSync from '../../UrlParamSync';

class TableConfigOverlay extends React.Component {
  static propTypes = {
    catalog: PropTypes.object.isRequired,
    catalogId: PropTypes.string.isRequired,
    viewSettings: PropTypes.object,
    viewMode: PropTypes.string,
    viewId: PropTypes.string,
  };

  onChange(key, value) {
    const { viewMode, viewId, catalogId } = this.props;

    viewSettingsActions.setOption({
      catalogId,
      viewMode,
      viewId,
      option: key,
      value,
    });
  }

  onSortChange(sortField, sortType) {
    const { viewMode, viewId } = this.props;
    const catalogId = this.props.catalog.get('id');

    const extractedFieldId = sortField && (sortField.get ? sortField.get('fieldId') : sortField.fieldId);

    viewSettingsActions.setSortingRecords({ catalogId, viewId, viewMode, sortField: extractedFieldId, sortType });
  }

  onSortFieldChange = (value) => {
    const { viewSettings } = this.props;
    const sortType = (viewSettings && viewSettings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.SORT_TYPE])) || -1;
    this.onSortChange(value, sortType);
  };

  onSortTypeChange = (value) => {
    const { viewSettings } = this.props;
    // API хранит fieldId
    let sortFieldId = viewSettings && viewSettings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.FIELD_ID]);
    // Если нет fieldId, используем дефолтное значение '#id'
    if (!sortFieldId) sortFieldId = '#id';
    let sortField = Immutable.fromJS({ type: 'field', fieldId: sortFieldId });
    this.onSortChange(sortField, value);
  };

  render() {
    const { catalog, viewSettings, t } = this.props;

    const fields = catalog && catalog.get('fields');

    // viewSettings уже содержит настройки только для текущего viewMode
    const color = viewSettings && viewSettings.get(SETTINGS_KEYS.COLOR);

    // API хранит sortingRecords: { sortType: -1, fieldId: '5' }
    const sortingRecords = viewSettings && viewSettings.get(SETTINGS_KEYS.SORTING_RECORDS);
    let sortFieldId = sortingRecords && sortingRecords.get(SETTINGS_KEYS.FIELD_ID);
    let sortField = sortFieldId && Immutable.fromJS({ type: 'field', fieldId: sortFieldId });
    const sortType = (sortingRecords && sortingRecords.get(SETTINGS_KEYS.SORT_TYPE)) || -1;

    const hasColor = fields && fields.find((field) => field.get('type') === FIELD_TYPES.DROPDOWN);

    return (
      <div className={cn('ant-dropdown-menu ant-dropdown-menu-vertical', styles.overlay)}>
        {/* Подсветка записей */}
        {hasColor && (
          <Row className={styles.controlRow}>
            <label className={styles.controlLabel}>{t('records.cards.config.color.label')}</label>
            <SelectColor fields={fields} value={color} onChange={(value) => this.onChange(SETTINGS_KEYS.COLOR, value)} />
          </Row>
        )}

        {/* Сортировка */}
        <Row className={styles.controlRow}>
          <label className={styles.controlLabel}>{t('records.cards.config.sort.label')}</label>
          <SelectSort fields={fields} value={sortField} onChange={this.onSortFieldChange} />
          <SelectSortDirection
            catalog={catalog}
            value={sortType}
            style={{ marginTop: '4px' }}
            onChange={this.onSortTypeChange}
          />
        </Row>
      </div>
    );
  }
}

export default withTranslation()(TableConfigOverlay);
